import { upInfo, insuranceApprove } from './request';
import topTitle from '@/components/title';
import planTemplateModel from './infoFrom/planTemplateModel.vue';
import additionalModel from './infoFrom/additionalModel.vue';
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
export default {
  components: {
    topTitle,
    planTemplateModel,
    additionalModel,
    quillEditor
  },
  data() {
    return {
      quillOption: quillConfig,
      templateShow: false,
      additionalShow: false,
      type: this.$route.params.type,
      dataFrom: {
        reviewNodeId: this.$route.params.id
      },
      form: {
        reminder: {
          name: ""
        },
        feature: {
          name: ''
        },
        copywriting: []
      }
    };
  },
  created() {
    upInfo({
      reviewNodeId: this.$route.params.id
    }).then(res => {
      console.log(res, 9999);
      this.form = res;
    });
  },
  methods: {
    downloadFun() {
      if (!this.form.planTemplate) {
        this.$message.error(this.$t('暂时无法下载'));
        return false;
      }
      window.location.href = this.form.planTemplate;
    },
    // seeplanTemplateFun(){
    //     this.templateShow=true;
    //     this.$nextTick(()=>{
    //         this.$refs.templateFrom.init(this.form.rendering)
    //     })
    // },
    seeAdditionalFun() {
      this.additionalShow = true;
      this.$nextTick(() => {
        this.$refs.additionalFrom.init(this.form.attachInfo);
      });
    },
    onSubmit(status) {
      if (!this.dataFrom.content) {
        this.$message.error(this.$t('请输入') + this.$t('审核意见'));
        return false;
      }
      this.dataFrom.status = status;
      insuranceApprove(this.dataFrom).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        this.$router.go(-1);
      });
    }
  }
};